import appModule from './app.module'

appModule
  .config(["$stateProvider", "$urlRouterProvider", "version", "ENV", function ($stateProvider, $urlRouterProvider, version) {
    var states = [
      {
        name: 'root',
        template: `
                    <super-user-banner ng-if="$root.currentUser.isSuperUser && $root.currentUser.originalTenantId !== $root.currentUser.tenant.id"></super-user-banner>
                    <shared-context-react></shared-context-react>
                    <new-sidebar></new-sidebar>
                    <ui-view></ui-view>
                `
      },
      {
        name: 'authentication',
        template: `
                    <shared-context-react></shared-context-react>
                    <ui-view></ui-view>
                `
      },
      {
        name: 'adminApp',
        template: `
                    <super-user-banner ng-if="$root.currentUser.isSuperUser && $root.currentUser.originalTenantId !== $root.currentUser.tenant.id"></super-user-banner>
                    <shared-context-react></shared-context-react>
                    <ui-view></ui-view>
                `
      },
      {
        name: 'adminApp.shell',
        url: '/admin-app/{section}',
        // section is owned by AdminAppShell (React); squash keeps plain
        // /admin-app valid and dynamic stops ui-router from re-entering the
        // state (remounting the shell) when only the section changes
        params: {
          section: { value: '', squash: true, dynamic: true }
        },
        baseUrl: '/admin-app',
        templateUrl: `/views/AdminApp/index.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Admin'
        },
        protected: true
      },
      {
        name: 'root.home',
        url: '/',
        baseUrl: '/',
        templateUrl: `/views/Home/Index.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP'
        },
        protected: true
      },
      {
        name: 'authentication.login',
        url: '/account?ReturnUrl',
        baseUrl: '/account',
        templateUrl: `/views/Account/SignIn.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Account Sign In'
        },
        protected: false
      },
      {
        name: 'authentication.forgot-password',
        url: '/account/forgot-password',
        baseUrl: '/account/forgot-password',
        templateUrl: `/views/Account/ForgotPassword.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Account Reset'
        },
        protected: false
      },
      {
        name: 'authentication.magic-link',
        url: '/magic-link?token',
        baseUrl: '/magic-link',
        templateUrl: `/views/Account/MagicLink.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Sign In'
        },
        protected: false
      },
      {
        name: 'authentication.reset-password-in-app',
        url: '/reset-password?token&email',
        baseUrl: '/reset-password',
        templateUrl: `/views/Account/ResetPasswordInApp.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Account Reset'
        },
        protected: false
      },
      {
        name: 'authentication.upgrade-handoff',
        url: '/upgrade/{outcome}?scheme&session_id',
        baseUrl: '/upgrade',
        templateUrl: `/views/Account/UpgradeHandoff.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Upgrade'
        },
        protected: false
      },
      {
        name: 'authentication.reset-password',
        url: '/account/reset-password?email&token',
        baseUrl: '/account/reset-password',
        templateUrl: `/views/Account/ResetPassword.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Account Reset'
        },
        protected: false
      },
      {
        name: 'root.account',
        url: '/account/details',
        baseUrl: '/account/details',
        templateUrl: `/views/Account/Details.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Account'
        },
        protected: true
      },
      {
        name: 'root.customers',
        url: '/customers',
        baseUrl: '/customers',
        template: `<customers-dispatch show-deleted="false"></customers-dispatch>`,
        data: {
          pageTitle: 'SynkedUP - Clients'
        },
        protected: true
      },
      {
        name: 'root.customersDeleted',
        url: '/customers/deleted',
        baseUrl: '/customers/deleted',
        template: `<customers-dispatch show-deleted="true"></customers-dispatch>`,
        data: {
          pageTitle: 'SynkedUP - Clients Deleted'
        },
        protected: true
      },
      {
        name: 'root.properties',
        url: '/customers/{id}/properties',
        baseUrl: '/customers',
        templateUrl: `/views/Properties/Index.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Client Properties'
        },
        protected: true
      },
      {
        name: 'root.propertiesDeleted',
        url: '/properties/deleted',
        baseUrl: '/properties/deleted',
        templateUrl: `/views/Properties/Index.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Client Properties Deleted'
        },
        protected: true
      },
      {
        name: 'root.customerAttachments',
        url: '/customers/{id}/attachments',
        baseUrl: '/customers',
        templateUrl: `/views/Attachments/Index.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Attachments'
        },
        protected: true
      },
      {
        name: 'root.customerPropertyAttachments',
        url: '/customers/{id}/properties/{propertyId}/attachments',
        baseUrl: '/customers',
        templateUrl: `/views/Attachments/Index.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Attachments'
        },
        protected: true
      },
      {
        name: 'root.estimates',
        url: '/estimates',
        baseUrl: '/estimates',
        templateUrl: `/views/ProjectsTickets/Estimates.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Project Estimates'
        },
        protected: true
      },
      {
        name: 'root.estimatesDeleted',
        url: '/estimates/deleted',
        baseUrl: '/estimates/deleted',
        templateUrl: `/views/ProjectsTickets/Estimates.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Project Estimates Deleted'
        },
        protected: true
      },
      {
        name: 'root.estimate',
        url: '/estimates/{id}',
        baseUrl: '/estimates',
        templateUrl: `/views/ProjectsTickets/Project.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Project Estimate'
        },
        protected: true
      },
      {
        name: 'root.projectEstimate',
        url: '/project-estimate/{id}',
        baseUrl: '/project-estimate',
        templateUrl: `/views/ProjectsTickets/Project.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Project Estimate'
        },
        protected: true
      },
      {
        name: 'root.projects',
        url: '/projects',
        baseUrl: '/projects',
        templateUrl: `/views/ProjectsTickets/Projects.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Projects'
        },
        protected: true
      },
      {
        name: 'root.projectsDeleted',
        url: '/projects/deleted',
        baseUrl: '/projects/deleted',
        templateUrl: `/views/ProjectsTickets/Projects.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Projects Deleted'
        },
        protected: true
      },
      {
        name: 'root.project',
        url: '/projects/{id}',
        baseUrl: '/projects',
        templateUrl: `/views/ProjectsTickets/Project.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Project'
        },
        protected: true
      },
      {
        name: 'root.tickets',
        url: '/tickets',
        baseUrl: '/tickets',
        templateUrl: `/views/ProjectsTickets/Tickets.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Service Tickets'
        },
        protected: true
      },
      {
        name: 'root.ticketsDeleted',
        url: '/tickets/deleted',
        baseUrl: '/tickets/deleted',
        templateUrl: `/views/ProjectsTickets/Tickets.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Service Tickets Deleted'
        },
        protected: true
      },
      {
        name: 'root.ticket',
        url: '/tickets/{id}',
        baseUrl: '/tickets',
        templateUrl: `/views/ProjectsTickets/ServiceTicket.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Service Ticket'
        },
        protected: true
      },
      {
        name: 'root.ticketEstimate',
        url: '/ticket-estimate/{id}',
        baseUrl: '/ticket-estimate',
        templateUrl: `/views/ProjectsTickets/ServiceTicket.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Service Ticket Estimate'
        },
        protected: true
      },
      {
        name: 'root.maintenances',
        url: '/maintenance',
        baseUrl: '/maintenance',
        templateUrl: `/views/ProjectsTickets/Maintenances.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Maintenance Tickets'
        },
        protected: true
      },
      {
        name: 'root.maintenancesDeleted',
        url: '/maintenance/deleted',
        baseUrl: '/maintenance/deleted',
        templateUrl: `/views/ProjectsTickets/Maintenances.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Maintenance Tickets Deleted'
        },
        protected: true
      },
      {
        name: 'root.maintenance',
        url: '/maintenance/{id}',
        baseUrl: '/maintenance',
        templateUrl: `/views/ProjectsTickets/Maintenance.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Maintenance Ticket'
        },
        protected: true
      },
      {
        name: 'root.maintenanceEstimate',
        url: '/maintenance-estimate/{id}',
        baseUrl: '/maintenance-estimate',
        templateUrl: `/views/ProjectsTickets/Maintenance.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Maintenance Ticket Estimate'
        },
        protected: true
      },
      {
        name: 'root.calendar',
        url: '/calendar?date&project&task',
        baseUrl: '/calendar',
        templateUrl: `/views/Calendar/Index.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Project & Ticket Calendar'
        },
        protected: true
      },
      {
        name: 'root.scheduling',
        url: '/scheduling?date&project&task',
        baseUrl: '/scheduling',
        templateUrl: `/views/Calendar/Index.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Scheduling'
        },
        protected: true
      },
      {
        name: 'root.time',
        url: '/time',
        baseUrl: '/time',
        template: `<time-page deleted-view="false"></time-page>`,
        data: {
          pageTitle: 'SynkedUP - Time'
        },
        protected: true
      },
      {
        name: 'root.timeDeleted',
        url: '/time/deleted',
        baseUrl: '/time/deleted',
        template: `<time-page deleted-view="true"></time-page>`,
        data: {
          pageTitle: 'SynkedUP - Time Deleted'
        },
        protected: true
      },
      {
        name: 'root.billing',
        url: '/billing',
        baseUrl: '/billing',
        templateUrl: `/views/Billing/Index.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Invoicing Console'
        },
        protected: true
      },
      {
        name: 'root.items',
        url: '/items',
        baseUrl: '/items',
        templateUrl: `/views/Items/Index.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Items'
        },
        protected: true
      },
      {
        name: 'root.itemsDeleted',
        url: '/items/deleted',
        baseUrl: '/items/deleted',
        templateUrl: `/views/Items/Index.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Items Deleted'
        },
        protected: true
      },
      {
        name: 'root.vendors',
        url: '/vendors',
        baseUrl: '/vendors',
        templateUrl: `/views/Vendors/Index.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Vendors'
        },
        protected: true
      },
      {
        name: 'root.templates',
        url: '/items/templates',
        baseUrl: '/items/templates',
        templateUrl: `/views/Items/Templates.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Templates'
        },
        protected: true
      },
      {
        name: 'root.templatesDeleted',
        url: '/items/templates/deleted',
        baseUrl: '/items/templates/deleted',
        templateUrl: `/views/Items/Templates.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Templates Deleted'
        },
        protected: true
      },
      {
        name: 'root.users',
        url: '/users',
        baseUrl: '/users',
        templateUrl: `/views/Users/Index.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Users'
        },
        protected: true
      },
      {
        name: 'root.usersDeleted',
        url: '/users/deleted',
        baseUrl: '/users/deleted',
        templateUrl: `/views/Users/Index.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Users Deleted'
        },
        protected: true
      },
      {
        name: 'root.tenants',
        url: '/tenants',
        baseUrl: '/tenants',
        templateUrl: `/views/Tenants/Owner.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Tenants'
        },
        protected: true
      },
      {
        name: 'root.mycompany',
        url: '/mycompany',
        baseUrl: '/mycompany',
        templateUrl: `/views/Tenants/MyCompany.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - My Company'
        },
        protected: true
      },
      {
        name: 'root.setup',
        url: '/setup',
        baseUrl: '/setup',
        templateUrl: `/views/Setup/Index.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Setup'
        },
        protected: true
      },
      {
        name: 'root.proposalSettings',
        url: '/proposal-settings',
        baseUrl: '/proposal-settings',
        templateUrl: `/views/ProposalSettings/Index.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Proposal Settings'
        },
        protected: true
      },
      {
        name: 'root.invoicingSettings',
        url: '/invoicing-settings',
        baseUrl: '/invoicing-settings',
        templateUrl: `/views/InvoicingSettings/Index.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Invoicing Settings'
        },
        protected: true
      },
      {
        name: 'root.routeSettings',
        url: '/route-settings',
        baseUrl: '/route-settings',
        templateUrl: `/views/RouteSettings/Index.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Route Settings'
        },
        protected: true
      },
      {
        name: 'root.consultations',
        url: '/consultations',
        baseUrl: '/consultations',
        templateUrl: `/views/Consultations/Index.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Consultations'
        },
        protected: true
      },
      {
        name: 'not-found',
        url: '/not-found',
        baseUrl: '/not-found',
        templateUrl: `/views/Shared/NotFound.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Not Found'
        },
        protected: false
      },
      {
        name: 'root.datacenter',
        url: '/datacenter',
        baseUrl: '/datacenter',
        templateUrl: `/views/Home/datacenter.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Datacenter'
        },
        protected: true
      },
      {
        name: 'root.schedule',
        url: '/routing',
        baseUrl: '/routing',
        templateUrl: `/views/Calendar/schedule.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Routing'
        },
        protected: true
      },
      {
        name: 'root.schedule2',
        url: '/schedule',
        baseUrl: '/schedule',
        templateUrl: `/views/Calendar/schedule.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Schedule'
        },
        protected: true
      },
      {
        name: 'root.payments',
        url: '/payments',
        baseUrl: '/payments',
        templateUrl: `/views/Billing/Payments.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Payments'
        },
        protected: true
      },
      {
        name: 'root.paymentsTab',
        url: '/payments/{tab}',
        baseUrl: '/payments',
        templateUrl: `/views/Billing/Payments.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Payments'
        },
        protected: true
      },
      {
        name: 'root.jobRedirect',
        url: '/job-redirect/{jobId}',
        baseUrl: '/job-redirect',
        templateUrl: `/views/ProjectsTickets/JobRedirect.html?v=${version}`,
        data: {
          pageTitle: 'SynkedUP - Job Redirect'
        },
        protected: true
      }
    ];
    states.forEach(function (state) {
      $stateProvider.state(state);
    });
    $urlRouterProvider.otherwise('/');
  }])

